import { GameView } from "./render";
import { Game } from "./Game";
import { Hud } from "./ui/hud";
import { THEME_PACKS, DEFAULT_THEME_ID } from "./theme";
import "./styles.css";

const stage = document.getElementById("stage");
const hudRoot = document.getElementById("hud");
if (!stage || !hudRoot) throw new Error("缺少 #stage 或 #hud 挂载点");

const hud = new Hud(hudRoot);
const view = new GameView();
const game = new Game(view, hud, DEFAULT_THEME_ID);

hud.onHint(() => game.hint());
hud.buildThemes(THEME_PACKS, DEFAULT_THEME_ID, (id) => game.setTheme(id));

await game.start(stage);
